import { FC } from 'react';
import classnames from 'classnames';
import { RadioGroup, Form } from 'rsuite';
import { RsNumberInput } from '../Input';
import { RadioCell } from './RadioCell';
import styles from './priceRadio.module.scss';

interface PriceDataType {
  value: string;
  label: string;
  hint?: React.ReactNode;
  disabled?: boolean;
  errorMessage?: string;
}

type Prices = Record<string, string>;
interface RsPriceRadioProps {
  data: PriceDataType[];
  selected: string;
  onChange: (s: string) => void;
  prices: Prices;
  onPriceChange: (p: Prices) => void;
  className?: string;
  disabled?: boolean;
}

export const RsPriceRadio: FC<RsPriceRadioProps> = ({
  data = [],
  selected = '',
  onChange = () => undefined,
  prices,
  onPriceChange,
  className = '',
  disabled = false,
}) => {
  const handleChange = (v) => {
    onChange(v);
  };

  return (
    <RadioGroup
      value={selected}
      onChange={handleChange}
      className={classnames(styles.RsPriceRadioGroup, className)}
      disabled={disabled}
      inline
    >
      {data.map(({ value, label, hint, errorMessage, ...rest }, i) => {
        const inputDisabled = disabled || value !== selected;

        const handlePriceChange = (newPrice) => {
          onPriceChange({ type: value, newPrice });
        };
        return (
          <RadioCell
            key={value}
            value={value}
            label={label}
            disabled={rest?.disabled}
            customRight={
              !inputDisabled && (
                <div className='relative'>
                  <RsNumberInput
                    prefix='NTD'
                    num={prices[value]}
                    onChange={handlePriceChange}
                    placeholder='請輸入金額' // i18n
                    disabled={inputDisabled}
                  />
                  <Form.ErrorMessage
                    show={errorMessage !== undefined}
                    placement='topEnd'
                  >
                    {errorMessage}
                  </Form.ErrorMessage>
                </div>
              )
            }
            customBottom={
              !inputDisabled && <Form.HelpText>{hint}</Form.HelpText>
            }
          />
        );
      })}
    </RadioGroup>
  );
};
